"use client";

import React from "react";
import { Phone, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ReadyToRefreshYourProperty() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="ready-to-refresh-your-property" className="dark bg-background text-foreground relative overflow-hidden py-24 sm:py-32">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-muted/20 pointer-events-none" />
      
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary/5 via-transparent to-transparent opacity-40 pointer-events-none" />

      <div ref={ref} className={cn("relative container mx-auto px-4 text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-foreground">
          Ready to Refresh Your Property?
        </h2>
        
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10">
          Proudly headquartered in Townsville, QLD, our team brings elite craftsmanship and meticulous attention to detail to every project across the North Queensland Region.
        </p>

        <div className="flex flex-col items-center gap-6">
          <TooltipProvider>
            <Tooltip delayDuration={0}>
              <TooltipTrigger asChild>
                {}
                <span tabIndex={0} className="inline-block rounded-md">
                  <Button size="lg" className="text-lg px-8 py-6 h-auto font-semibold shadow-lg shadow-primary/20 hover:shadow-primary/40 transition-all duration-300" asChild>
                    <Link to="/GetAQuotePage">
                      Get a Free Quote
                      <ArrowRight className="ml-2 size-5" />
                    </Link>
                  </Button>
                </span>
              </TooltipTrigger>
              <TooltipContent side="top" className="bg-secondary text-secondary-foreground border-border/50">
                <p>Response within 24 hours</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>

          <div className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors duration-300">
            <Phone className="size-4" />
            <span className="text-sm md:text-base">
              Or call us directly:{" "}
              <Link to="tel:0712345678" className="font-medium underline underline-offset-4 hover:text-primary-foreground transition-colors">0409 908 999</Link>
            </span>
          </div>
        </div>
      </div>
    </section>;
}